import { SET_DELETEFONT } from '../actions';

const fontdelete = (state = [], action) => {
  switch (action.type) {
	case SET_DELETEFONT:
      return [...action.value];  
    default: return state;
  }
}

export default fontdelete;
